import React, {useEffect, useState} from 'react';
import classNames from 'classnames';
import {find, get} from 'lodash';

export default function({row_data, impact_key, level_data, level_key, growthMin, hasInsight}) {

    const getInsights = () => {
        const render_insights = row_data.map((old_impact_data, old_impact_key) => {
            if (!old_impact_data || old_impact_key >= impact_key) {
                return null;
            }
            const old_level_data = old_impact_data[level_key];
            const old_percentage = old_level_data.percentage;
            const this_percentage = level_data.percentage;
            // For not_met and nearly_met, less % means growth insight
            if (level_key <= 1) {
                if (old_percentage - this_percentage >= growthMin) {
                    return (
                        <div key={old_impact_key} className="flex-row">
                            <div>
                                {level_data.level} % drops
                                <br />
                                from {old_level_data.percentage}% ({old_level_data.data.impact_study})
                                <br />
                                to {level_data.percentage}% ({level_data.data.impact_study})
                                <br />
                                having {old_level_data.percentage - level_data.percentage}% positive changes
                            </div>
                        </div>
                    );
                }
            } else {
                if (this_percentage - old_percentage >= growthMin) {
                    return (
                        <div key={old_impact_key} className="flex-row">
                            <div>
                                {level_data.level} % increases
                                <br />
                                from {old_level_data.percentage}% ({old_level_data.data.impact_study})
                                <br />
                                to {level_data.percentage}% ({level_data.data.impact_study})
                                <br />
                                having {level_data.percentage - old_level_data.percentage}% positive changes
                            </div>
                        </div>
                    );
                }
            }
            return null;
        });

        return (
            <div className="flex-column flex-gap-15">
                {render_insights}
            </div>
        );
    }

    if (!hasInsight) {
        return null;
    }

    return (
        <div className="growth-t-popup">
            {getInsights()}
        </div>
    );
}